import { FrontContent } from '../types'

export const frontContent: FrontContent = {
    title: 'Eirik Høgdahl Skjærseth',
    subtitle: '- Master in computer science, NTNU',
    imageUrl:
        'https://media-exp1.licdn.com/dms/image/C4D03AQGk2kqjW4z5rg/profile-displayphoto-shrink_200_200/0?e=1607558400&v=beta&t=Ycs6VJor8LSYzwFV81V5WM-i_rBAjVM7_rYCmvRL8sg',
}
